let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("g56i4")]).then(() => parcelRequire('cPayA'));